import { render } from "./ForgetEmailPwd.vue?vue&type=template&id=07b93300&scoped=true"
import script from "./ForgetEmailPwd.vue?vue&type=script&lang=js"
export * from "./ForgetEmailPwd.vue?vue&type=script&lang=js"

import "./ForgetEmailPwd.vue?vue&type=style&index=0&id=07b93300&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b93300"]])

export default __exports__